<app-loader [loading]="loading" [overlayState]="overlayState"></app-loader>
<div class="wbd-register-page">
  <div class="container h-100">
    <div class="row justify-content-center h-100">
      <div class="col-12 d-flex flex-column">
        <h1 class="wbd-register-title">{{registrationCon.wbdEmployeeRegistration}}</h1>

        <form class="wbd-register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="custom-floating-label mb-0 w-100">

            <input
              type="email"
              class="form-control wbd-register-input"
              placeholder="Your work email address"
              formControlName="email"
              (input)="onEmailChange()"
              [ngClass]="{
                'wbd-register-input-error':
                  (submitted && email?.invalid) || (errorMsg && email?.valid)
              }"
            />

            <div *ngIf="submitted && email?.invalid" class="w-100 text-start">
              <small *ngIf="email?.errors?.['required']" class="text-danger">
                {{registrationCon.emailRequired}}
              </small>
              <small *ngIf="email?.errors?.['email'] || email?.errors?.['pattern']" class="text-danger d-block">
                {{registrationCon.emailNotFound}}
              </small>
            </div>
            <div *ngIf="errorMsg && email?.valid" class="w-100 text-start">
              <small class="text-danger d-block">
                {{errorMsg}}
              </small>
            </div>
          </div>

          <button type="submit" class="common-btn-secondary btn" [disabled]="isDisabled">
            {{registrationCon.register}}
          </button>
        </form>

        <p class="wbd-register-footer-text">
          {{registrationCon.alreadyRegistered}}
          <a class="text-link" href="javascript:void(0)" (click)="onSignInAccess()">
            {{registrationCon.signInAccess}}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<ng-template #successTpl>
  <div class="success">
    {{registrationCon.registrationCompletedSuccessfully}}
  </div>
</ng-template>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>